import { AHText, Box, Input, useLayoutContext } from "arkh";
import React, { useState } from "react";

import { graphql, useLazyLoadQuery, useMutation } from "react-relay";
import { StoreAdminNavigationScreenProps } from "../StoreAdmin/StoreAdminNavigation";
import { KeyboardAwareScrollView } from "react-native-keyboard-controller";
import { useNavigationHeader } from "@/src/common/navigationHeaderOptions";
import { StorecastScreenAdminEditNameMutation } from "./__generated__/StorecastScreenAdminEditNameMutation.graphql";
import { StorecastScreenAdminEditNameQuery } from "./__generated__/StorecastScreenAdminEditNameQuery.graphql";
import { LazyQueryNetworkBoundrary } from "@/src/components/mobile/QueryNetworkBoundrary";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
export function StorecastScreenAdminEditNameScreen({
  navigation,
  route,
}: StoreAdminNavigationScreenProps<"ScreenAdminEditName">) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fetchKey) => (
        <StorecastScreenAdminEditNameComponent
          fetchKey={fetchKey}
          screenId={route.params.screenId}
          onBack={navigation.goBack}
        />
      )}
    </LazyQueryNetworkBoundrary>
  );
}

function StorecastScreenAdminEditNameComponent(props: {
  fetchKey: string;
  screenId: string;
  onBack: () => void;
}) {
  const data = useLazyLoadQuery<StorecastScreenAdminEditNameQuery>(
    graphql`
      query StorecastScreenAdminEditNameQuery($screenId: ID!) {
        storecast {
          screen(id: $screenId) {
            name
          }
        }
      }
    `,
    { screenId: props.screenId },
    {
      fetchPolicy: "store-and-network",
      fetchKey: props.fetchKey,
    }
  );

  const [saveName, setNameInFlight] =
    useMutation<StorecastScreenAdminEditNameMutation>(graphql`
      mutation StorecastScreenAdminEditNameMutation(
        $screenId: ID!
        $name: String!
      ) {
        storecast {
          setScreenName(screenId: $screenId, name: $name) {
            id
            name
          }
        }
      }
    `);

  const [name, setName] = useState(data.storecast.screen.name);

  useNavigationHeader({
    type: "SAVE",
    onCancel() {
      props.onBack();
    },
    disabled: name === data.storecast.screen.name,
    onSave() {
      saveName({
        variables: {
          name: name,
          screenId: props.screenId,
        },
        onCompleted: props.onBack,
      });
    },
    saveLoading: setNameInFlight,

    defaultContentStyle: true,
  });
  const { space } = useLayoutContext();
  const intl_tokens = useIntlTokens();

  return (
    <KeyboardAwareScrollView
      contentInsetAdjustmentBehavior="automatic"
      style={{ flex: 1 }}
      keyboardShouldPersistTaps="handled"
      contentContainerStyle={{
        padding: space.medium,
        paddingVertical: space.medium,
      }}
    >
      <Box spaceVertical="small">
        <AHText spaceBottom="small" spaceHorizontal="xsmall" type="title-small">
          {intl_tokens.Name}
        </AHText>
        <Input
          autoCapitalize="words"
          value={name}
          onChangeText={setName}
          autoFocus
        />
      </Box>
    </KeyboardAwareScrollView>
  );
}
